import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../../Hooks/useFormName';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import { InputProps } from '../../../../../Components/Form/components/Input';
import RichText from '../RichText/RichText';
import BirthDatePicker from './BirthDatePicker';
import InputWrapper from '../../../../../Components/Form/components/InputWrapper/InputWrapper';

interface Props extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	isWrapped?: boolean;
}

const BirthDatePickerField: React.FC<Props> = ({
	name,
	label,
	isRequired,
	className,
	isWrapped,
}: Props) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<BirthDatePicker value={field.value} onChange={field.onChange} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default BirthDatePickerField;
